const COMMON_KEY = "messaging";

export const MessagingQueryKeys = {
  contacts: () => [COMMON_KEY, "contacts"] as const,
  chats: (searchTerm?: string) => [COMMON_KEY, "chats", searchTerm] as const,
  messages: (chatId: string | null) =>
    [COMMON_KEY, "messages", chatId] as const,
  onlineStatuses: (customerIDs: string[]) =>
    [COMMON_KEY, "onlineStatuses", customerIDs] as const,
  customerToChatOnAccountDetails: (campaignId: string, accountId: string) =>
    [
      COMMON_KEY,
      "customerToChatOnAccountDetails",
      campaignId,
      accountId,
    ] as const,
};
